// Test WG
import React, { useState, useMemo } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ProtectedRoute } from "../auth/ProtectedRoute.jsx";
import Home from "./Home.jsx";
import { Deconnexion } from "./Deconnexion";
import SignInForm from "../auth/signInForm";
import { ComputerDataProvider } from "../context/ComputerDataContext";
import { getDecryptedParamsFromURL } from "../util/decryption";

function App() {
  const queryParameters = new URLSearchParams(window.location.search);
  const debug = queryParameters.get("debug") === "true";

  // Récupère les valeurs chiffrées brutes (a et b) depuis l'URL
  const encryptedA = queryParameters.get("a");
  const encryptedB = queryParameters.get("b");

  // Détecte l'ancienne méthode de connexion via uid=
  const legacyUid = queryParameters.get("uid");

  // Déchiffre les paramètres URL (a=email chiffré, b=password chiffré)
  const decryptedParams = useMemo(() => getDecryptedParamsFromURL(), []);

  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("encrypted_a") && localStorage.getItem("encrypted_b") ? true : false
  );
  const [uidValue, setUidValue] = useState(localStorage.getItem("uid"));

  return (
    <Router>
      <Routes>
        {/* Route publique */}
        <Route
          path="/"
          element={
            legacyUid ? (
              <Navigate to="/deconnexion?legacy=true" />
            ) : (
              <SignInForm
                email={decryptedParams?.id}
                password={decryptedParams?.password}
                encryptedA={encryptedA}
                encryptedB={encryptedB}
                isAuthenticated={isAuthenticated}
                setIsAuthenticated={setIsAuthenticated}
                setUidValue={setUidValue}
                debug={debug}
              />
            )
          }
        />
        {/* Route de déconnexion */}
        <Route path="/deconnexion" element={<Deconnexion />} />

        {/* Route protégée */}
        <Route
          path="/home"
          element={
            <ProtectedRoute
              isAuthed={isAuthenticated}
              uid={uidValue}
              isLoading={false}
            >
              <ComputerDataProvider userId={uidValue}>
                <Home clientUid={uidValue} />
              </ComputerDataProvider>
            </ProtectedRoute>
          }
        />

        {/* Gestion des chemins non trouvés */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
